var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ps-page"},[_c('div',{staticClass:"ps-page__title"},[_vm._v("Produkte & Fulfillment")]),_c('PrintVariants'),_c('ExtrasSettings'),_c('SkuMapping'),_c('ProductTypes'),_c('PrintShops')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }